import React from "react";
import { LuLoader } from "react-icons/lu";

const Loader = () => {
  return (
    <div className="loader fixed inset-0 bg-white bg-opacity-50 flex items-center justify-center modal-index">
    <LuLoader size={80} className='animate-spin text-black' style={{animationDuration: '350ms'}} />
  </div>
  );
};

export default Loader;
